function newsletterComponent() {
    $('.form-landing').closest('.form').parent().append('<div class="loader" style="display: none;"/>');
    $('.checkbox-container').each(function () {
        var height = $(this).find('label').outerHeight() + 8;
        $(this).attr('style', 'height: ' + height + 'px;');
    });
    $('#newsletter-subscribe input[type="email"]').on('input', function () {
        hideStep2();
    });
    $('#newsletter-subscribe .btn-next').on('click tap', function (e) {
        e.preventDefault();
        $('#checkbox3').parent().find('label').removeClass('red');
        if ($('#newsletter-subscribe input[type="email"]').valid() && $('#checkbox3').is(':checked')) {
            showStep2();
        }
        else {
            $('#newsletter-subscribe').submit();
        }
    });
    $('.newsletter-subscribe-landing input[type="email"]').on('keyup', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (event.keyCode == 13 /* ENTER */) {
            if ($(this).valid()) {
                showStep2();
            }
        }
    });
    $('#newsletter-step-2').hide();
    $('#newsletter-subscribe button[type=submit]').hide();
    function showStep2() {
        if ($('.newsletter-subscribe-landing').length > 0) {
            $('#newsletter-step-2').slideDown(400);
        }
        else {
            $('#newsletter-subscribe .btn-next').hide(0, () => {
                $('#newsletter-step-2').slideDown(400);
            });
        }
    }
    function hideStep2() {
        $('#newsletter-step-2').slideUp(400, () => {
            $('#newsletter-subscribe .btn-next').show();
        });
    }
    $('#newsletter-subscribe').on("submit", function (e) {
        e.preventDefault();
        var $form = $('#newsletter-subscribe');
        const isLandingPage = $('#newsletter-subscribe').hasClass('newsletter-subscribe-landing');
        $('#checkbox3').parent().find('label').removeClass('red');
        if (!$('#checkbox3').prop('checked')) {
            $('#checkbox3').parent().find('label span, label a').addClass('red');
            showMessageBox('danger', msg['MSG_MUST_ACCEPT_TERMS']);
            return;
        }
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function (data) {
                if (isLandingPage) {
                    $('.form-landing').closest('.form').hide();
                    $('.loader').show();
                }
            },
            success: function (data) {
                if (data.success) {
                    $('#newsletter-step-2').hide();
                    $('#newsletter-subscribe .email-input').val('');
                    showMessageBox('success', msg['MSG_NEWSLETTER_COMPLETED']);
                    dataLayer.push({ 'event': 'subscribe-newsletter' });
                    // landing page
                    if (isLandingPage) {
                        var baseUrl = window.location.href;
                        if (baseUrl.endsWith('/')) {
                            baseUrl = baseUrl.slice(0, -1);
                        }
                        baseUrl = baseUrl.split('/').slice(0, -1).join('/');
                        setTimeout(() => window.location.href = baseUrl + '/landing-countdown-subscribe-done', 2000);
                    }
                }
                else {
                    if (data.errors.message == 'Invalid email')
                        showMessageBox('danger', msg['ERR_INVALIDMAIL']);
                    else if (data.errors.message == 'Invalid captcha code')
                        showMessageBox('danger', msg['MSG_INVALID_CAPTCHA']);
                    else if (data.errors.message == 'Login to your account')
                        showMessageBox('danger', msg['MSG_USER_ALREADY_REGISTERED']);
                    else
                        showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
                    expiredNewsletterCaptcha();
                    // landing page
                    if (isLandingPage) {
                        setTimeout(function () {
                            $('.form-landing').closest('.form').show();
                            $('.loader').hide();
                            grecaptcha.reset();
                        }, 1000);
                    }
                    else {
                        grecaptcha.reset();
                    }
                }
            },
            error: function (data) {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
                expiredNewsletterCaptcha();
                $('.form-landing').closest('.form').show();
                $('.loader').hide();
                grecaptcha.reset();
            },
        });
    });
}
function subscribeNewsletterCaptcha() {
    $('#newsletter-subscribe button[type="submit"]').show(400);
}
function expiredNewsletterCaptcha() {
    $('#newsletter-subscribe button[type="submit"]').hide(400);
}
